// My tasks (/org/tasks...): one inbox with the tabs My quarter · To confirm ·
// To report (pages/TasksPage.tsx). In the app shell (OrgShell). /org/tasks
// opens on My quarter. The old addresses forward here.
import { extra, moved, page, type AreaRoute } from "../../routes/types";

const tasksPage = page(() => import("./pages/TasksPage"), "TasksPage");

export const routes: AreaRoute[] = [
  extra("/org/tasks", tasksPage),
  extra("/org/tasks/quarter", tasksPage),
  extra("/org/tasks/confirm", tasksPage),
  extra("/org/tasks/report", tasksPage),
  moved("/org/my-quarter", "/org/tasks/quarter"),
  moved("/org/confirm", "/org/tasks/confirm"),
  moved("/org/to-report", "/org/tasks/report"),
];
